import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mst_entity_event_RowInterface, bl_fi_mst_entity_event_RowClass } from "../../../dbschema";

export class EntityEventContainerModel extends BaseContainerModel {
  bl_fi_mst_entity_event: bl_fi_mst_entity_event_RowInterface = new bl_fi_mst_entity_event_RowClass();
}
